module.exports = __webpack_public_path__ + "static/media/kesho-logo-light.d28fcf1d.png";